import Vue from "vue";
import Vuex from "vuex";
import register from "./register.js"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    register
  }
});
